// require('./bootstrap');
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import ProposalComponent from './components/Example';
import ContractComponent from './components/Contract';
import EditContractTemplate from './components/EditContractTemplate';
import EditProposalTemplate from './components/EditProposalTemplate';
import ProposalNewBuilder from './components/ProposalNewBuilder';
import EditProposalNewBuilderTemplate from './components/EditProposalNewBuilderTemplate';
import ContractNewBuilder from './components/ContractNewBuilder';
import EditContractNewBuilderTemplate from './components/EditContractNewBuilderTemplate';
function App() {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ProposalComponent, {})
  });
}
function Contract() {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ContractComponent, {})
  });
}
function EditProposal() {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(EditProposalTemplate, {})
  });
}
function EditContract() {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(EditContractTemplate, {})
  });
}
import NewBuilderStandalone from './components/NewBuilderStandalone';
import { generateHtml } from './components/NewBuilder/utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
var rootScope = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : globalThis;
rootScope.generateHtml = generateHtml;
function mountReactComponents() {
  if (typeof document === 'undefined') return;
  if (document.getElementById('proposal-section')) {
    ReactDOM.render( /*#__PURE__*/_jsx(App, {}), document.getElementById('proposal-section'));
  }
  if (document.getElementById('proposal-new-builder-section')) {
    ReactDOM.render( /*#__PURE__*/_jsx(ProposalNewBuilder, {}), document.getElementById('proposal-new-builder-section'));
  }
  if (document.getElementById('contract-new-builder-section')) {
    ReactDOM.render( /*#__PURE__*/_jsx(ContractNewBuilder, {}), document.getElementById('contract-new-builder-section'));
  }
  if (document.getElementById('contract-section')) {
    ReactDOM.render( /*#__PURE__*/_jsx(Contract, {}), document.getElementById('contract-section'));
  }
  if (document.getElementById('edit-proposal-template')) {
    ReactDOM.render( /*#__PURE__*/_jsx(EditProposal, {}), document.getElementById('edit-proposal-template'));
  }
  if (document.getElementById('edit-proposal-new-builder-template')) {
    ReactDOM.render( /*#__PURE__*/_jsx(EditProposalNewBuilderTemplate, {}), document.getElementById('edit-proposal-new-builder-template'));
  }
  if (document.getElementById('edit-contract-new-builder-template')) {
    ReactDOM.render( /*#__PURE__*/_jsx(EditContractNewBuilderTemplate, {}), document.getElementById('edit-contract-new-builder-template'));
  }
  if (document.getElementById('edit-contract-template')) {
    ReactDOM.render( /*#__PURE__*/_jsx(EditContract, {}), document.getElementById('edit-contract-template'));
  }
  if (document.getElementById('standalone-builder')) {
    ReactDOM.render( /*#__PURE__*/_jsx(NewBuilderStandalone, {}), document.getElementById('standalone-builder'));
  }
}
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountReactComponents);
  } else {
    mountReactComponents();
  }
}